import { atom } from "jotai";

export const bottomBarSpacingOverrideAtom = atom<string | undefined>(undefined);
